import { render, staticRenderFns } from "./WonderfulVideo.vue?vue&type=template&id=ecff15bc&scoped=true"
import script from "./WonderfulVideo.vue?vue&type=script&lang=js"
export * from "./WonderfulVideo.vue?vue&type=script&lang=js"
import style0 from "./WonderfulVideo.vue?vue&type=style&index=0&id=ecff15bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecff15bc",
  null
  
)

export default component.exports